/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DataFunnelModal } from '@interfaces';
import { LeadService } from '@services';
import { EMOJIS } from 'src/app/pages/commercial-executive/leads/dashboard-table/constants';

@Component({
  selector: 'unicon-bulk-message-modal',
  standalone: false,
  templateUrl: './bulk-message-modal.component.html',
  styleUrl: './bulk-message-modal.component.scss',
})
export class BulkMessageModalComponent {
  protected stageName: string;
  protected leadsCount = 0;
  protected leadsCountBlocked = 0;
  protected message: string = '';
  protected selectedTemplate: string = 'Saludo';
  protected showEmojiPicker = false;
  // Lista amplia de emojis similar a los usados en Whatsapp
  protected emojiList: string[] = EMOJIS;
  protected leadsWithoutTemplate?: string[];
  protected leadsWithTemplate?: string[];
  protected isLoading = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DataFunnelModal,
    public dialogRef: MatDialogRef<BulkMessageModalComponent>,
    private leadService: LeadService,
  ) {
    this.stageName = data.name;
    this.leadsCount = data.count;
    this.leadsWithoutTemplate = data.leadsWithoutTemplate;
    this.leadsWithTemplate = data.leadsWithTemplate;
  }

  protected onSend() {
    this.isLoading = true;
    const request: any = {};
    if ((this.leadsWithoutTemplate ?? []).length > 0) {
      request['leadsWithFreeMessage'] = {
        leadIds: this.leadsWithoutTemplate || [], // Aquí se deberían agregar los IDs de los leads sin plantilla
        message: this.message,
      };
    }
    if ((this.leadsWithTemplate ?? []).length > 0) {
      request.leadsWithTemplate = {
        leadIds: this.leadsWithTemplate || [],
      };
    }
    this.leadService.sendBulkMessage(request).subscribe({
      next: () => {
        this.isLoading = false;
        this.dialogRef.close();
      },
      error: () => {
        this.isLoading = false;
      },
    });
  }

  protected closeModal() {
    this.dialogRef.close();
  }

  // Toggle emoji picker visibility (stop propagation to avoid closing parent dialogs)
  protected toggleEmojiPicker(event: Event) {
    event.stopPropagation();
    this.showEmojiPicker = !this.showEmojiPicker;
  }

  // Handler for emoji selection from emoji-mart
  protected onEmojiSelect(event: any) {
    // emoji-mart libraries may emit different payload shapes; try common properties
    const emoji =
      event?.native ||
      event?.emoji?.native ||
      event?.colons ||
      event?.shortname ||
      '';
    if (emoji) {
      this.message = `${this.message || ''}${emoji}`;
    }
    this.showEmojiPicker = false;
  }
}
